export default __webpack_public_path__ + "img/b8644b6e04ecda1cf98bbb37f17d0ef3.woff2";